/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { useContext } from 'preact/hooks';
import { EnvironmentContext } from '../../UNSAFE_Environment';

export function useTheme() {
  return useContext(EnvironmentContext).theme;
}
